import React from 'react'
import style from "./Card.module.css"

const Card = ({ name, jobtitle, description }) => {
  return (
    <div className={style.card}>
      <p className={style.name}>{name}</p>
      <p className={style.jobtitle}>{jobtitle}</p>
      <p className={style.description}>{description}</p>
    </div>
  )
}

export default Card